import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { IUpdateExpoTokenPayload, IUpdateExpoTokenResponse } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the update expo notification token mutation keys in react query cache.
 */
const MUT_UPDATE_EXPO_NOTIFICATION_TOKEN =
  'update-expo-notification-key-mutation-key';

/**
 * The useUpdateExpoTokenMutation Props
 */
export interface IUseLogoutOptions {
  /**
   * Callback on a successful logout.
   */
  onSuccessCallback?: (
    data: IUpdateExpoTokenResponse | null,
    payload: IUpdateExpoTokenPayload | null
  ) => void;
  /**
   * Callback on a failed logout.
   */
  onErrorCallback: (err: IApiError) => void;
}

/**
 * This updates the expo notification token on the server.
 */
export const useUpdateExpoTokenMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IUseLogoutOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_UPDATE_EXPO_NOTIFICATION_TOKEN],
    networkMode: 'always',
    mutationFn: USER_ACCOUNTS_API.updateExpoNotificationToken,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      errorLogToRemoteUtil({
        error: err,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'useUpdateExpoTokenMutation Error',
        message: err?.message,
      });
      onErrorCallback(err);

      return err;
    },
  });

  return {
    error,
    isPending,
    updateToken: mutate,
  };
};
